"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DIService = (function () {
    function DIService(props) {
        this.apiKey = props.apiKey || 'aK%2BoyU4DhAV5w0KwF4bWDfMEpM5RfJRK';
        this.serviceUrl = props.serviceUrl || 'https://ws.di.no/ws/json/addressHelper/v-2';
    }
    DIService.prototype.fetchFromDi = function (relativeUrl) {
        var _this = this;
        var url = "".concat(this.serviceUrl).concat(relativeUrl).concat(relativeUrl.includes('?') ? '' : '?', "&apiKey=").concat(this.apiKey, "&limitToOfficial=false");
        return fetch(url, {
            method: 'GET',
            headers: {
                Referer: 'http://aftenposten'
            }
        })
            .then(function (res) { return _this.checkError(res); })
            .then(function (res) { return res.text(); })
            .then(function (text) { return text.length ? JSON.parse(text) : {}; });
    };
    DIService.prototype.checkError = function (res) {
        if (res.status >= 200 && res.status < 300) {
            return res;
        }
        return res.text().then(function (text) {
            var error = new Error(res.statusText);
            error.response = "".concat(res.status, ": ").concat(text || res.statusText);
            error.status = res.status;
            error.data = text;
            error.requestUuid = res.headers.get("x-snoam-request-uuid");
            throw error;
        });
    };
    DIService.prototype.fetchStreetCollections = function (searchString) {
        var url = "/NO/streetSearch/".concat(searchString);
        return this.fetchFromDi(url);
    };
    DIService.prototype.fetchStreetNumbers = function (streetIds, query) {
        var url = "/NO/streetNumberSearch/".concat(streetIds.join(), "?&streetNumber=").concat(encodeURIComponent(query || ''));
        return this.fetchFromDi(url);
    };
    DIService.prototype.fetchFloors = function (deliveryPointId) {
        var url = "/NO/address/".concat(deliveryPointId, "/floors");
        return this.fetchFromDi(url);
    };
    DIService.prototype.fetchHousholds = function (floor, deliveryPointId) {
        var url = "/NO/address/".concat(deliveryPointId, "/floor/").concat(floor.floorType, "-").concat(floor.floorNo, "/households");
        return this.fetchFromDi(url);
    };
    return DIService;
}());
exports.default = DIService;
//# sourceMappingURL=DIService.js.map